import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Components
import Button from '../../../../components/buttons/Button';
import Icon from '../../../../components/icons/Icon';
import LoadableAppRegister from '../../../../auth/modals/register/LoadableAppRegister';

// Selectors
import { getLocationQuery, getUrlPermissionId } from '../../../../app/routingSelector';
import { getCurrentBoardId } from '../../../../reducers/currentBoardId/currentBoardIdSelector';
import { buildAppRegisterOverlayUrl } from '../../../../auth/modals/register/registrationUtils';

// Actions
import { navigateToUrl } from '../../../../reducers/navigationActions';
import { openSheet } from '../../../structural/sheet/sheetActions';

// Constants
import { REGISTRATION_ENTRY_POINT } from '../../../../user/userConstants';
import { PUBLISH_FEEDBACK_REGISTRATION_ONBOARDING } from '../../../../../common/users/userEducationConstants';
import { SheetId } from '../../../structural/sheet/sheetTypes';

// Styles
import './MobileGuestUtilsToolList.scss';

const MobileGuestUtilsToolList = () => {
    const dispatch = useDispatch();

    const currentBoardId = useSelector(getCurrentBoardId);
    const urlPermissionId = useSelector(getUrlPermissionId);
    const locationQuery = useSelector(getLocationQuery);

    const openReportContentSheet = () => dispatch(openSheet(SheetId.ReportContent));

    useEffect(() => {
        LoadableAppRegister.preload();
    }, []);

    const appRegisterUrl = buildAppRegisterOverlayUrl({
        currentBoardId,
        permissionId: urlPermissionId,
        locationQuery,
        registrationEntryPoint: REGISTRATION_ENTRY_POINT.PUBLISHED_REGISTRATION,
        onboarding: PUBLISH_FEEDBACK_REGISTRATION_ONBOARDING,
    });

    const navigateToRegister = useCallback(() => {
        dispatch(navigateToUrl(appRegisterUrl));
    }, [appRegisterUrl]);

    return (
        <div className="MobileUtilsToolList MobileGuestUtilsToolList">
            <Button className="mobile-util-button" onClick={navigateToRegister}>
                <Icon name="mobile-toolbar-login" />
                <div className="label">Log in</div>
            </Button>
            <Button className="mobile-util-button" onClick={openReportContentSheet}>
                <Icon name="mobile-toolbar-report-content" />
                <div className="label">Report this</div>
            </Button>
        </div>
    );
};

export default MobileGuestUtilsToolList;
